import authenticationModule from "./authenticationModule"
import gatewayServer from "../gatewayServer"


authenticationModule.service("authenticationService", ["$localStorage", "$http", "$httpParamSerializer", "supplyService", function ($localStorage, $http, $httpParamSerializer, supplyService) {

    let authenticationCallbacks = []
    let targetState = null
    let targetStateParams = null

    /**
     * @returns {boolean} true se o usuário atual estiver autenticado
     */
    this.isAuthenticated = function isAuthenticated() {
        return !!this.getUserToken()
    }

    /**
     * Armazena a url especificada para uso posterior. Tipicamente, esta url reflete a intenção de um usuário, ainda
     * não autenticado, acessar um recusro. Pode ser obtida pós login para redirecionamento através de #getTargetUrl()
     */
    this.setTargetState = (state, params) => {
        targetState = state
        targetStateParams = params
    }

    /**
     * Retorna a url configurada anteriormente.
     */
    this.getTargetState = function getTargetState() {
        return targetState
    }

    this.getTargetStateParams = () => {
        return targetStateParams
    }

    this.addAuthenticationCallback = Array.prototype.push.bind(authenticationCallbacks)

    /**
     * Autentica o usuário a partir das credenciais especificadas.
     * @param login nome do usuário
     * @param password senha
     * @param tenantId id do tenant que possui o usuario, ou null
     * @returns {Promise}
     */
    this.authenticate = function authenticate(login, password, tenantId) {
        $localStorage["tenantId"] = tenantId
        return $http({
            url: gatewayServer.getServiceUrl("authentication"),
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded", "applicationClient": "default"},
            data: $httpParamSerializer({
                username: login,
                password: password
            })
        }).then((response) => {
            setLoginInStorage(response)
        })
    }

    function setLoginInStorage(response) {
        $localStorage["user.token"] = response.data.token
        $localStorage["current.user.name"] = response.data.username
        $localStorage["password.remaining.days"] = response.data.passwordRemainingDays
        $localStorage["tenantId"] = response.data.tenantId
        $localStorage.$apply()
        authenticationCallbacks.forEach((callback) => {
            if (callback.onLogIn) {
                callback.onLogIn()
            }
        })
    }

    this.authenticateSupplyWithToken = function authenticateWithToken(token, tenantId) {
        $localStorage["tenantId"] = tenantId
        return $http({
            url: gatewayServer.getServiceUrl("authentication-supply"),
            method: "POST",
            headers: {"Content-Type": "application/json", "token": token},
        }).then((response) => {
            supplyService.activateSupplyMode()
            return setLoginInStorage(response)
        })
    }

    this.isUserExists = function (login, password) {
        return $http({
            url: gatewayServer.getServiceUrl("isUserExists"),
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded", "applicationClient": "default"},
            data: $httpParamSerializer({
                username: login,
                password: password
            })
        })
    }

    /**
     * Finaliza a sessão do usuário.
     */
    this.logOut = function logOut() {
        delete $localStorage["user.token"]
        supplyService.inactivateSupplyMode()
        authenticationCallbacks.forEach((callback) => {
            if (callback.onLogOut) {
                callback.onLogOut()
            }
        })
    }

    /**
     * Retorna o token do usuário atualmente logado.
     */
    this.getUserToken = function () {
        return $localStorage["user.token"]
    }

    this.validateToken = () => {
        let userToken = this.getUserToken()
        if (!userToken) {
            return
        }
        return $http.get(gatewayServer.getServiceUrl("token") + userToken)
            .then(() => {
                authenticationCallbacks.forEach((callback) => {
                    if (callback.onLogIn) {
                        callback.onLogIn()
                    }
                })
            })
    }
    this.renewSupplySession = () => {
        let userToken = this.getUserToken()
        return $http({
            url: gatewayServer.getServiceUrl("renew-supply-session"),
            method: "POST",
            headers: {"Content-Type": "application/json", "token": userToken},
        })
    }

    this.getCurrentUserName = () => {
        return $localStorage["current.user.name"]
    }

    this.getPasswordRemainingDays = () => {
        return $localStorage["password.remaining.days"]
    }

    this.getTenantId = () => {
        return $localStorage["tenantId"]
    }
}])